import React, { useEffect, useState, useRef } from 'react';
import { PageHeader, Tabs, Table, Tag, Button, Typography, Divider, Radio } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

import * as IMI from '../../lib/ManiaFrameWork/js/mania';

import Image01_Src from '../../media/images/20190808_133759.png';
import Image02_Src from '../../media/images/20190808_133645.png';
import Image03_Src from '../../media/images/20190808_133836.png';
import Image04_Src from '../../media/images/20190808_133850.png';

const { TabPane } = Tabs;
const { Title, Paragraph } = Typography;

const routes = [
  {
    path: '/',
    breadcrumbName: 'Display',
  },
  {
    path: 'Carousel',
    breadcrumbName: 'Carousel',
  },
];
const columns = [
  {
    title: 'Option Name',
    dataIndex: 'name',
    key: 'name',
    render: text => <b>{text}</b>,
  },
  {
    title: 'Propertys',
    key: 'tags',
    dataIndex: 'tags',
    render: tags => (
      <span>
        {tags.map(tag => {
          let color = '#1890ff'
          return (
            <Tag color={color} key={tag}>
              {tag}
            </Tag>
          );
        })}
      </span>
    ),
  },
];

const data = [
  {
    key: '1',
    name: 'carouselMotion',
    tags: ['default', 'slide', 'fade', 'prev'],
  },
  {
    key: '2',
    name: 'autoMove',
    tags: ['true', 'false'],
  },
  {
    key: '3',
    name: 'autoMoveTime',
    tags: ['1000', '2000', '3000', '...'],
  },
  {
    key: '4',
    name: 'navigation',
    tags: ['true', 'false'],
  },
  {
    key: '5',
    name: 'pagination',
    tags: ['object', 'false'],
  },
  {
    key: '6',
    name: 'pagination-position',
    tags: ['bottom', 'top'],
  },
  {
    key: '7',
    name: 'pagination-color',
    tags: ['default', '#159EFD', 'skyblue'],
  },
];



const CarouselReady = (element, options) => {
  new IMI.Carousel(
    element,
    !options
      ? {
        carouselMotion: 'default',
        navigation: true,
        pagination: {
          position:'bottom'
        },
        autoMove: true,
        autoMoveTime: 2000
      }
      : options
  );
};


const Carousel_ = () => {
  const carouselRef = useRef(null);
  const isInitialMount = useRef(true);

  const [navigation, setNavigation] = useState(true);
  const [pagination, setPagination] = useState(true);
  const [autoMove, setAutoMove] = useState(true);
  const [motions, setMotions] = useState('default');
  const [paginationPos, setPaginationPos] = useState('bottom');
  const [paginationColors, setPaginationColors] = useState('');

  const baseHtml = `
    <div class="carousel" id="carousel-banner">
      <div class="carousel-wrapper">
        <div class="carousel-item"><img src=${Image01_Src} alt="BMW3 series front" /></div>
        <div class="carousel-item"><img src=${Image02_Src} alt="BMW3 series back" /></div>
        <div class="carousel-item"><img src=${Image03_Src} alt="BMW3 series left" /></div>
        <div class="carousel-item"><img src=${Image04_Src} alt="BMW3 series right" /></div>
      </div>
      <div class="navi-wrapper"></div>
    </div>`;

  const onChangeMotion = e => { setMotions(e.target.value); }
  const ChangeNavigation = () => setNavigation(!navigation);
  const ChangePagination = () => setPagination(!pagination);
  const AutoMoveCarousel = () => setAutoMove(!autoMove);
  const onChangePaginationPos = e => setPaginationPos(e.target.value);
  const onChangePaginationColors = e => setPaginationColors(e.target.value);

  useEffect(() => {
    if (isInitialMount.current) { // componentDidMount
      CarouselReady(carouselRef.current.children[0]);
      isInitialMount.current = false;
    } else {
      const options = {
        carouselMotion: motions,
        navigation: navigation,
        autoMove: autoMove,
        autoMoveTime: 2000
      }
      if(pagination === true) {
        options.pagination = {
          position : paginationPos,
          color : paginationColors
        }
      } else {
        options.pagination = pagination
      }
      carouselRef.current.innerHTML = baseHtml;
      CarouselReady(carouselRef.current.children[0], options);
    }
  }, [navigation, autoMove, motions, pagination, paginationPos, paginationColors]);


  return (
    <>
      <PageHeader title="Carousel" breadcrumb={{ routes }} subTitle="Carousel" style={{ padding: 10 }} />


      <div className="MF_area" ref={carouselRef}>
        <div className="carousel" id="carousel-banner">
          <div className="carousel-wrapper">
            <div className="carousel-item"><img src={Image01_Src} alt="BMW3 series front" /></div>
            <div className="carousel-item"><img src={Image02_Src} alt="BMW3 series back" /></div>
            <div className="carousel-item"><img src={Image03_Src} alt="BMW3 series left" /></div>
            <div className="carousel-item"><img src={Image04_Src} alt="BMW3 series right" /></div>
          </div>
        </div>
      </div>

      <Paragraph style={{ padding: 10 }}>
        <Title level={3}>Handdler</Title>
        <Divider />
        <Title level={4}>Motions</Title>
        <Radio.Group onChange={onChangeMotion} defaultValue={motions}>
          <Radio.Button value="default">Default</Radio.Button>
          <Radio.Button value="slide">Slide</Radio.Button>
          <Radio.Button value="fade">Fade</Radio.Button>
          <Radio.Button value="prev">Prev</Radio.Button>
        </Radio.Group>
        <Divider />

        <Title level={4}>Auto-Move && Navigation && Pagination</Title>
        <Button type="primary" onClick={AutoMoveCarousel} style={{ marginRight: 10 }}>{autoMove ? 'AutoMove ON' : 'AutoMove OFF'}</Button>
        <Button type="primary" onClick={ChangeNavigation} style={{ marginRight: 10 }}>{navigation ? 'Navigation ON' : 'Navigation OFF'}</Button>
        <Button type="primary" onClick={ChangePagination}>{pagination ? 'Pagination ON' : 'Pagination OFF'}</Button>
        <Divider />

        <Title level={4}>Pagination-Positions</Title>
        <Radio.Group onChange={onChangePaginationPos} defaultValue={paginationPos}>
          <Radio.Button value="bottom">bottom</Radio.Button>
          <Radio.Button value="top">top</Radio.Button>
        </Radio.Group>

        <Title level={4}>Pagination-Active-Colors</Title>
        <Radio.Group onChange={onChangePaginationColors} defaultValue={paginationColors}>
          <Radio.Button value="">default</Radio.Button>
          <Radio.Button value="blue">blue</Radio.Button>
          <Radio.Button value="black">black</Radio.Button>
        </Radio.Group>
      </Paragraph>


      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="carousel" id="carousel-banner">
  <div class="carousel-wrapper">
    <div class="carousel-item"><img src="image src..." /></div>
    <div class="carousel-item"><img src="image src..." /></div>
    <div class="carousel-item"><img src="image src..." /></div>
    <div class="carousel-item"><img src="image src..." /></div>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
          <TabPane tab="JAVASCRIPT" key="2">
            <CodeHighlight language="JS">
              {`new Carousel(document.querySelector('#carousel-banner'), {
    carouselMotion: 'default',
    navigation: true,
    pagination: {
      position:'bottom'
    },
    autoMove: true,
    autoMoveTime: 2000
});`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
      <Table columns={columns} dataSource={data} />
    </>
  );
}

export default Carousel_;
